; (function ($, undefined) {

	var app = {
		vars: {
			animationSpeed: {
				in: 1000,
				out: 500
			}
		},
		dom: {
			init: function () {
				var handleScroll = function () {
					var scroll = window.scrollY;
					var header = document.querySelector('.header--main');
					//animation
					if (scroll > 0) {
						header.classList.add('fixed');
					}
					else {
						header.classList.remove('fixed');
					}

				}
				document.addEventListener('scroll', handleScroll);
				handleScroll();

				//mobile menu fix
				var openButton = document.querySelector('[data-burger-open]');
				var closeButton = document.querySelector('[data-burger-close]');
				var body = document.querySelector('body');

				openButton.addEventListener('click', function (e) {
					document.querySelector('html').style.overflow = 'hidden';
				})
				closeButton.addEventListener('click', function (e) {
					document.querySelector('html').style.overflow = 'auto';
				})

				var menuAnchors = document.querySelectorAll('.nav--main .menu a');

				for(var i = 0; i<menuAnchors.length; i++){
					menuAnchors[0].addEventListener('click', function(){
						if (!menuAnchors[0].parentNode.classList.contains('menu-item-has-children')) {
							body.classList.remove('menu-visible');
							document.querySelector('html').style.overflow = 'auto';
						}
					})
				}

			}
		},

		utils: {
			rem: function (val) {
				var mul = parseInt(app.dom.$html.css('font-size')) / 10;

				return val * mul;
			},

			msieversion: function () {
				var ua = window.navigator.userAgent;
				var msie = ua.indexOf("MSIE ");
				if (msie > 0 || !!navigator.userAgent.match(/Trident.*rv\:11\./)) return true;
				else return false;
			},

			t: function (key) {
				if (window._translations !== undefined && window._translations[key] !== undefined) {
					return window._translations[key];
				} else {
					return key;
				}
			},

			showVideoModal: function () {

			},

			getScrollBarWidth: function () {
				var inner = document.createElement('p');
				inner.style.width = "100%";
				inner.style.height = "200px";

				var outer = document.createElement('div');
				outer.style.position = "absolute";
				outer.style.top = "0px";
				outer.style.left = "0px";
				outer.style.visibility = "hidden";
				outer.style.width = "200px";
				outer.style.height = "150px";
				outer.style.overflow = "hidden";
				outer.appendChild(inner);

				document.body.appendChild(outer);
				var w1 = inner.offsetWidth;
				outer.style.overflow = 'scroll';
				var w2 = inner.offsetWidth;
				if (w1 == w2) w2 = outer.clientWidth;

				document.body.removeChild(outer);

				return (w1 - w2);
			}
		},


		inview: {
			init: function () {
				var windowHeight = $(window).height();

				$(window).on('load domready resize', function () {
					windowHeight = $(window).height();
					$('[data-inview]').each(function () {
						$(this).prop("inviewOffset", ($(this).attr('data-inview-offset') ? $(this).attr('data-inview-offset') : .8));
					});
					app.inview.checkInview(windowHeight, $(window).scrollTop());
				})

				$(window).on('scroll', $.throttle(200, function () {
					app.inview.checkInview(windowHeight, $(window).scrollTop());
				}));

			},

			checkInview: function (windowHeight, windowScrollTop) {
				$('[data-inview]').each(function () {
					if ($(this).offset().top < windowScrollTop + $(this).prop('inviewOffset') * windowHeight) {
						if (!$(this).attr('data-inview')) {
							$(this).attr('data-inview', 'active');
						}
					}
				})
			}
		},

		nav: {
			vars: {},

			init: function () {
				app.nav.bindBurger();
			},

			bindBurger: function () {

				app.dom.$body.on('click', '[data-burger-open]', function (e) {
					e.preventDefault();
					console.log('open')

					app.dom.$body.addClass('menu-visible');
				});

				app.dom.$body.on('click', '[data-burger-close]', function (e) {
					e.preventDefault();
					console.log('close')
					console.log(e.target)
					if (app.dom.$body.hasClass('menu-visible')) {
						app.dom.$body.addClass('menu-hide-anim');
						setTimeout(function () {
							app.dom.$body.removeClass('menu-hide-anim');
						}, 800);
					} else {
						app.dom.$body.removeClass('menu-hide-anim');
					}

					app.dom.$body.removeClass('menu-visible');
				});

				app.dom.$body.on('pageOut', function () {
					setTimeout(function () {
						app.dom.$body.addClass('menu-hide-immediately');
						app.dom.$body.removeClass('menu-visible');
						setTimeout(function () {
							app.dom.$body.removeClass('menu-hide-immediately');
						}, 100);
					}, 1000);
				});
			}
		},

		header: {
			init: function () {

				app.dom.$body.on('click', 'header .main-menu a', function (e) {

					var href = $(this).attr('href').split('#')[1];
					var offset = $('#' + href).offset().top;

					if (offset > 0) {
						e.preventDefault();

						$('html,body').animate({
							scrollTop: offset
						}, 1200, 'easeInOutQuint', function () {
							$('html,body').scrollTop(offset);
						});
					}
				});

			}
		},

		init: function () {
			app.dom.$window = $(window);
			app.dom.$document = $(document);
			app.dom.$html = $('html');
			app.dom.$body = $('body');
			app.baseUrl = app.dom.$body.attr('data-base-href');

		},

		run: function () {
			app.init();

			for (var i in app) {
				if (typeof (app[i]) == 'object' && app[i].init !== undefined) {
					app[i].init();
				}
			}

			app.dom.$window.trigger('domready');
		}
	};

	$(document).ready(function () {
		app.run();

		$('.nav--main .menu > .menu-item-has-children > a').click(function (e) {
			e.preventDefault();

			if ($(window).width() < 1024) {
				$(this).parent().toggleClass('active');
				$(this).next().slideToggle();
			}

		})

		$('.js-accordion-btn').click(function() {
			var attr = this.getAttribute('aria-expanded')
			console.log(attr == 'false')

			if (attr == 'false') {
				this.setAttribute('aria-expanded', 'true');
				$(this).next().slideDown(400)
			} else {
				this.setAttribute('aria-expanded', 'false');
				$(this).next().slideUp(400)
			}
		})

		/* cookies code */
		$('.cookies-box__close').click(function () {
			setCookie('cookies-accept', 'accepted', 1);
			$('.cookies-popup').fadeOut();
		});

		if (document.querySelector('.js-marquee')) {
			var marWidth = $('.js-marquee .marquee__container:first-child').width();
			document.querySelector('.js-marquee').style = `--marqueeMove: ${marWidth}px`;

			window.onresize = function () {
				var marWidth = $('.js-marquee .marquee__container:first-child').width();
				document.querySelector('.js-marquee').style = `--marqueeMove: ${marWidth}px`;
			}
		}

		$('.testimonials-wrapper').owlCarousel({
			loop: false,
			margin: 20,
			autoHeight: true,
			nav: true,
			navText: ['<button type="button" class="slider__btn slider__btn--left"> </button>', '<button type="button" class="slider__btn slider__btn--right"> </button>'],
			center: true,
			autoWidth: true,
			dots: true,
			items: 1
		});

		$('.js-video').on('click', function () {
			var iframe = $(this).attr('data-iframe');
			var modal = document.createElement('DIV');
			var content = document.createElement('DIV');
			modal.classList.add('modal', 'js-close');
			content.classList.add('modal__content');
			content.innerHTML += iframe;
			modal.append(content);
			$('body').append(modal);
			$('.modal').fadeIn(400);

			$('.js-close').on('click', function (e) {
				if ($(e).currentTarget == $(e).eventTarget) {
					$('.modal').fadeOut(400, function () {
						$('.modal').remove();
					});
				}
			});
		});

		$('.cookies-box__btn1').click(function () {
			setCookie('cookies-accept', 'accepted', 360);
			$('.cookies-popup').fadeOut();
		});

		function setCookie(key, value, days) {
			var expires = new Date();
			expires.setTime(expires.getTime() + (days * 24 * 60 * 60 * 1000));
			document.cookie = key + '=' + value + ';expires=' + expires.toUTCString();
		}

		function getCookie(key) {
			var keyValue = document.cookie.match('(^|;) ?' + key + '=([^;]*)(;|$)');
			return keyValue ? keyValue[2] : null;
		}

		function delete_cookie(name) {
			document.cookie = name + '=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
		}

		var cookie_val = getCookie('cookies-accept');

		if (cookie_val !== 'accepted') {
			$('.cookies-popup').fadeIn();
		}

		if (document.querySelector('.js-popup-pro')) {
			var cookie = getCookie('medical-pro');

			if (cookie !== 'confirmed') {
				$('html').addClass('show-popup-pro');

				$('.js-pro-confirm').click(function () {
					setCookie('medical-pro', 'confirmed', 30);
					$('html').removeClass('show-popup-pro');
				})

				$('.js-pro-decline').click(function () {
					$('.js-popup-pro').addClass('redirecting');
					window.location = window.location.origin;
				})
			}
		}
	});

})(window.jQuery);
